import React, { useContext } from 'react';
import { TrailContext } from './TrailContext';
import { Link } from 'react-router-dom';
import '../CSS/AllTrails.css';

function AllTrails() {

    const [trails] = useContext(TrailContext);

    return (
        <div className="page">
            <div className="heading">
                <h1 className="title">Here are all the trails.</h1>
            </div>
            <div className="trailsContainer">
                {trails.map(trail => (
                    <Link key={trail.url} style={{display: 'block', color: 'black', textDecoration: 'none'}} to={`/trails/${trail.url}`}>
                        <div className="trailItem">
                            <h2 className="trailItem__name">{trail.name}</h2>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default AllTrails;